export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8708.d96f91dd.jpg";